'use strict';
/* eslint-disable */
var dialog = require('_core_ext/dialog'),
    productStoreInventory = require('_core/storeinventory/product'),
    util = require('_core_ext/util'),
    addToCart = require('./addToCart'),
    availability = require('_core/pages/product/availability'),
    productNav = require('_core_ext/pages/product/productNav'),
    productSet = require('_core_ext/pages/product/productSet'),
    variant = require('./variant');
    import slickSlider from '../../components/common/SlickSlider';

/**
 * @description Initialize product detail page with reviews, recommendation and product navigation.
 */
function initializeDom() {
    productNav();
}

/**
 * @description Initialize event handlers on product detail page
 */
function initializeEvents() {
    var $pdpMain = $('#pdpMain');

    addToCart.init();
    availability();
    variant.init();
    productSet.init();
    if (SitePreferences.STORE_PICKUP) {
        productStoreInventory.init();
    }

    // Add to Wishlist and Add to Gift Registry links behaviors
    $pdpMain.on('click', '[data-action="wishlist"], [data-action="gift-registry"]', function () {
        var data = util.getQueryStringParams($('.pdpForm').serialize());
        if (data.cartAction) {
            delete data.cartAction;
        }
        var url = util.appendParamsToUrl(this.href, data);
        this.setAttribute('href', url);
    });

    // product options
    $pdpMain.on('change', '.product-options select', function () {
        var salesPrice = $pdpMain.find('.product-add-to-cart .price-sales');
        var selectedItem = $(this).children().filter(':selected').first();
        salesPrice.text(selectedItem.data('combined'));
    });

    // prevent default behavior of thumbnail link and add this Button
    $pdpMain.on('click', '.thumbnail-link, .unselectable a', function (e) {
        e.preventDefault();
    });

    $(document).on('click', '.js-share-icon', function (e) {
        $(this).siblings('.js-share-content').toggleClass('is--hidden');
    });
    if($('#product-images #pdp-images-slider').length > 0) {
        $('#product-images #pdp-images-thumbnail').html($('#product-images #pdp-images-slider').html());
    }
    var viewportWidth = $(window).width();
    if(viewportWidth <= 991) {
        slickSlider.slidePDPMainImage($('#product-images #pdp-images-mobile-slider'), true, '', true);
    } else {
        let $pdpDesktopImgSlider = $('#product-images #pdp-images-slider');
        var $pdpDesktopImgThumb = $('#product-images #pdp-images-thumbnail');
        let params = {asNavFor: "#pdp-images-thumbnail", infinite: true};
        slickSlider.slidePDPMainImage($pdpDesktopImgSlider, true, params);
        params = {asNavFor: "#pdp-images-slider", arrows: false, infinite: false, slidesToShow: 9, focusOnSelect: true };
        slickSlider.slidePDPMainImage($pdpDesktopImgThumb, false, params);
        var slickObj = $pdpDesktopImgSlider.slick('getSlick');
        var slideTimer;
        $pdpDesktopImgThumb.on('mouseenter', '.slick-slide', function (e) {
            let $currTarget = $(e.currentTarget);
            $pdpDesktopImgThumb.find('.slick-slide').removeClass('slick-current');
            $currTarget.addClass('slick-current');
            slideTimer = setTimeout(function () {
                let index = $pdpDesktopImgThumb.find('.slick-current').data('slick-index');
                slickObj.slickGoTo(index, true);
            }, 0);
        }).on('mouseleave', '.slick-slide', function (e) {
            clearTimeout(slideTimer);
        });
    }

    $(document).on('click', '.shopthelook-btn', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $("#shopthelook").offset().top
        }, 800);
    });

    $(window).on('load', function() {
        var isShopTheLook = $('div.shop-the-look');
        var hideShopTheLook = $('div.shop-the-look').hasClass('is--hidden');
        if(isShopTheLook.length > 0 && !(hideShopTheLook)){
            $('.shopthelook-btn').removeClass('d-none');
        }
    });
}

var product = {
    initializeEvents: initializeEvents,
    init: function () {
        initializeDom();
        initializeEvents();
    }
};

module.exports = product;
